import { useState } from "react";
import { InstRequests } from "@/components/inst/InstRequests";
import { InstProducts } from "@/components/inst/InstProducts";

export function InstModeling() {
  const [view, setView] = useState("requests");
  return (
    <div>
      <div className="inline-flex border border-zinc-300 bg-white mb-5">
        {[["requests", "Quote Requests"], ["products", "Products & Options"]].map(([k, l]) => (
          <button key={k} onClick={() => setView(k)} data-testid={`inst-modeling-view-${k}`}
            className={`px-4 py-2 text-sm transition-colors ${view === k ? "bg-[#0F172A] text-white" : "text-zinc-600 hover:bg-zinc-100"}`}>{l}</button>
        ))}
      </div>
      {view === "requests" ? <InstRequests /> : <InstProducts />}
    </div>
  );
}
